import { useLayoutEffect, useRef } from 'react';

export default function AutoFitText({ children, maxFontSize, style }) {
  const textRef = useRef(null);

  useLayoutEffect(() => {
    const element = textRef.current;
    if (!element) return undefined;

    const fit = () => {
      element.style.fontSize = `${maxFontSize}px`;
      const availableWidth = element.clientWidth;
      const renderedWidth = element.scrollWidth;

      if (availableWidth > 0 && renderedWidth > availableWidth) {
        element.style.fontSize = `${Math.max(1, maxFontSize * (availableWidth / renderedWidth) * 0.98)}px`;
      }
    };

    fit();

    if (typeof ResizeObserver === 'undefined') {
      window.addEventListener('resize', fit);
      return () => window.removeEventListener('resize', fit);
    }

    const observer = new ResizeObserver(fit);
    observer.observe(element);
    return () => observer.disconnect();
  }, [children, maxFontSize]);

  return (
    <div ref={textRef} style={{ ...style, fontSize: `${maxFontSize}px`, whiteSpace: 'nowrap' }}>
      {children}
    </div>
  );
}
